<app-sidebar></app-sidebar>
<section class="p-[0.5rem] md:!px-8 md:!py-6 bg-grey-200 flex-1 overflow-y-scroll" cdkScrollable>
    <router-outlet></router-outlet>
</section>